// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"DeleteConfirmModal_buttonContainer__XfZtV","buttonSpace":"DeleteConfirmModal_buttonSpace__1Qt5c"};